import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Theme } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { formatRoundNumber } from '../../../shared/utils';

const useStyles = makeStyles<Theme>(({ spacing, palette }) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 25,
    top: 25,
  },
  label: {
    fontSize: 14,
  },
  icon: {
    color: palette.primary.main,
    display: 'inline-block',
    margin: spacing(0, 1),
  },
  number: {
    color: colorPalette.grey.mainHover,
    fontSize: 20,
    '& > .highlight': {
      color: palette.primary.main,
    },
  },
}));

interface Props {
  won?: number;
  total?: number;
}

export function PromocodesWon({ won = 0, total = 0 }: Props): React.ReactElement {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        {t('rewards.promo-codes.status.message')}
        <span className={classes.icon}>
          <FontAwesomeIcon icon={faTrophy} />
        </span>
      </div>
      <div className={classes.number}>
        <span className="highlight">{formatRoundNumber(won)}</span>/{formatRoundNumber(total)}
      </div>
    </div>
  );
}
